// extracted by mini-css-extract-plugin
module.exports = {"override":"override__1TakA"};